export default __webpack_public_path__ + "static/media/Ripper of the Faceless Chaos.d8acfb09.jpg";